<div #viewportRoot class="virtual-list-viewport">
  <div class="virtual-list-viewport__spacer" [style.height.px]="topSpacerHeight"></div>

  <div
    *ngFor="let entry of visibleItems; trackBy: trackVisibleItem"
    #renderedItem
    class="virtual-list-viewport__item"
    [attr.data-virtual-key]="entry.key"
    [style.margin-bottom.px]="entry.index < items.length - 1 ? itemGap : 0"
  >
    <ng-container
      *ngTemplateOutlet="resolvedTemplate; context: { $implicit: entry.item, item: entry.item, index: entry.index, key: entry.key }"
    ></ng-container>
  </div>

  <div class="virtual-list-viewport__spacer" [style.height.px]="bottomSpacerHeight"></div>
  <div
    *ngIf="appendLoading && appendPlaceholder != null"
    class="virtual-list-viewport__item virtual-list-viewport__append-loading"
    [style.margin-top.px]="items.length ? itemGap : 0"
    aria-hidden="true"
  >
    <ng-container
      *ngTemplateOutlet="resolvedTemplate; context: {
        $implicit: appendPlaceholder, item: appendPlaceholder, index: items.length, key: 'append-placeholder'
      }"
    ></ng-container>
  </div>
  <div #appendSentinel class="virtual-list-viewport__append-sentinel" aria-hidden="true"></div>
</div>
